<div>
    @switch (isEvenYear) {
        @case (true) {
            <slot name="even-year-variant"></slot>
        }
        @default {
            <slot name="odd-year-variant"></slot>
        }
    }
</div>